
const domainName = window.location.hostname;
const newStageUrl = 'https://uatapi.llpsales.com';
const newLiveUrl = 'https://api.llpsales.com';
const oldUrl = 'http://3.228.238.128';
console.log('Domain Name:', domainName);

const oldApi = {
    // ==========7000==========
    baseUrl1: `${oldUrl}:7001`,
    // ==========9000==========
    baseUrl00: `${oldUrl}:9000`,
}

const stageApi = {
    // staging/local/UIPL server
    // ==========7000==========

    //http://3.228.238.128:7001 
    baseUrl1: `${newStageUrl}`,
    // ==========9000==========
    //http://3.228.238.128:9000
    baseUrl00: `${newStageUrl}`,
}

const liveApi = {

    // Live
    // ==========7000==========

    //http://3.228.238.128:7001    
    baseUrl1: `${newLiveUrl}`,
   
    // ==========9000==========

    //http://3.228.238.128:9000
    baseUrl00: `${newLiveUrl}`,   

}

const api = domainName === 'localhost' ? stageApi : liveApi;
console.log(api, 'domain name');

export default api;

